
import React, { useRef } from "react";
import { ChatMessages } from "./ChatMessages";
import { AIReportingChatInput } from "./AIReportingChatInput";
import ErrorBoundary from "@/components/common/ErrorBoundary";
import { Message } from "@/types/reportTypes";

interface Props {
  messages: Message[];
  isLoading: boolean;
  input: string;
  setInput: (v: string) => void;
  handleSendMessage: () => void;
}

export const AIReportingChatWindow: React.FC<Props> = ({
  messages,
  isLoading,
  input,
  setInput,
  handleSendMessage,
}) => {
  const messagesEndRef = useRef<HTMLDivElement>(null);

  return (
    <div className="flex flex-col flex-1">
      <div className="flex-grow overflow-y-auto border rounded-md p-4 bg-card">
        <ErrorBoundary componentName="ChatMessages">
          <ChatMessages messages={messages} isLoading={isLoading} />
        </ErrorBoundary>
        <div ref={messagesEndRef} />
      </div>
      <ErrorBoundary componentName="AIReportingChatInput">
        <AIReportingChatInput
          input={input}
          setInput={setInput}
          isLoading={isLoading}
          handleSendMessage={handleSendMessage}
        />
      </ErrorBoundary>
    </div>
  );
};
